import stringSimilarity from 'string-similarity'

export const compareStrings = stringSimilarity.compareTwoStrings
export const findBestStringMatch = stringSimilarity.findBestMatch
